export default __webpack_public_path__ + "static/media/043-wool.3d70c74d.svg";